<template>
  <v-container fluid>
    <v-row justify="end">
      <v-col align="right">
        <nuevo-expediente-dialog-component v-if="perfil === 'Antecedentes'" />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="searchExpediente"
          label="Buscar folio"
          dense
          rounded
          filled
          color="secondary"
          background-color="primary"
          append-icon="mdi-magnify"
        />
      </v-col>
      <v-col cols="12">
        <v-card
          color="primary"
          class="card"
        >
          <v-data-table
            :headers="expedienteHeaders"
            :items="expedientes"
            class="transparent"
            :search="searchExpediente"
          >
            <template #[`item.folio`]="{ item }">
              <div
                v-if="item.folio !== ''"
                class="text-body-2 font-weight-bold d-inline"
              >
                {{ item.folio }}
              </div>
              <div
                v-else
                class="text-body-2 font-weight-bold d-inline"
              >
                N/A
              </div>
              <v-btn
                small
                icon
                class="d-inline"
                color="secondary"
                @click="openEditFolioExpedienteDialog(item)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <template #[`item.Personal`]="{ item }">
              <div class="text-subtitle-2">
                {{ getFullName(item.Personal) }}
              </div>
            </template>
            <template #[`item.opciones`]="{ item }">
              <v-btn
                v-if="perfil !== 'Programación'"
                small
                rounded
                color="secondary"
                class="mx-2"
                @click="openExpedientePersonalDialog(item)"
              >
                Ver expediente
              </v-btn>
              <v-btn
                v-if="perfil === 'Programación'"
                small
                rounded
                color="secondary"
                class="mx-2"
                @click="openNuevaProgramacionDialog(item)"
              >
                Registrar proceso de evaluación
              </v-btn>
              <v-btn
                v-if="perfil === 'Programación'"
                small
                rounded
                color="secondary"
                class="mx-2"
                @click="openListaProgramacionesDialog(item)"
              >
                Lista de programaciones
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <expediente-personal-dialog-component
      :active="expedientePersonalDialog"
      :expediente="selectedExpediente"
      @close="expedientePersonalDialog = false"
    />
    <editar-folio-expediente-dialog-component
      :active="editarFolioExpedienteDialog"
      :expediente="selectedExpediente"
      @close="editarFolioExpedienteDialog = false"
    />
    <nueva-programacion-dialog-component
      :active="nuevaProgramacionDialog"
      :expediente="selectedExpediente"
      @close="nuevaProgramacionDialog = false"
    />
    <lista-programaciones-dialog-component
      :active="listaProgramacionesDialog"
      :expediente="selectedExpediente"
      @close="listaProgramacionesDialog = false"
    />
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="black"
      opacity="0.68"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import EditarFolioExpedienteDialogComponent from '../../components/expediente/EditarFolioExpedienteDialogComponent.vue';
import ExpedientePersonalDialogComponent from '../../components/expediente/ExpedientePersonalDialogComponent.vue';
import NuevoExpedienteDialogComponent from '../../components/NuevoExpedienteDialogComponent.vue';
import ListaProgramacionesDialogComponent from '../../components/programacion/ListaProgramacionesDialogComponent.vue';
import NuevaProgramacionDialogComponent from '../../components/programacion/NuevaProgramacionDialogComponent.vue';

export default {
  name: 'ExpedientesView',
  components: {
    ExpedientePersonalDialogComponent,
    EditarFolioExpedienteDialogComponent,
    NuevoExpedienteDialogComponent,
    NuevaProgramacionDialogComponent,
    ListaProgramacionesDialogComponent,
  },

  data() {
    return {
      loadingExpediente: false,
      overlay: false,

      searchExpediente: '',

      expedienteHeaders: [
        {
          text: 'Folio',
          value: 'folio',
        },
        {
          text: 'Evaluado',
          value: 'Personal',
        },
        {
          text: 'Antigüedad en la institución',
          value: 'antiguedadInstitucion',
        },
        {
          text: 'Opciones',
          value: 'opciones',
        },
      ],

      selectedExpediente: {},

      // Dialogs
      expedientePersonalDialog: false,
      editarFolioExpedienteDialog: false,
      nuevaProgramacionDialog: false,
      listaProgramacionesDialog: false,
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('expediente', {
      expedientes: 'getExpedientes',
    }),

    ...mapGetters({
      idPersonal: 'getIdPersonal',
    }),
  },

  methods: {
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),
    ...mapActions('parentesco', ['fetchParentesco']),
    ...mapActions('areas', ['fetchAreas']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosExpediente']),
    ...mapActions('familiares', ['fetchFamiliares']),
    ...mapActions('documento', ['fetchDocumentoByPersonal']),
    ...mapActions('vehiculos', ['fetchVehiculos']),
    ...mapActions('boletasArresto', ['fetchBoletasArresto']),
    ...mapActions('sancionesAdministrativas', ['fetchSancionesAdministrativas']),
    ...mapActions('situacionFinanciera', ['fetchSituacionFinanciera']),
    ...mapActions('datosLaborales', ['fetchDatosLaborales']),
    ...mapActions('evaluacionesMedico', ['fetchEvaluacionesMedicoByExpediente']),
    ...mapActions('evaluacionesPsicologicas', ['fetchEvaluacionesPsicologicasByExpediente']),
    ...mapActions('evaluacionesPoligrafo', ['fetchEvaluacionesPoligrafoByExpediente']),
    ...mapActions('evaluacionesISE', ['fetchEvaluacionesIseByExpediente']),
    ...mapActions('evaluacionesValidacion', ['fetchEvaluacionesValidacionByExpediente']),
    ...mapActions('historiaClinica', ['fetchHistoriasClinicasByExpediente']),
    ...mapActions('programacionEvaluacion', ['fetchProgramacionesEvaluacionesByExpediente']),
    ...mapActions('evaluacionesIntegracion', ['fetchEvaluacionesIntegracionByExpediente']),
    ...mapActions('seguimientoEvaluaciones', ['fetchSeguimientoEvaluacionByExpediente']),
    ...mapActions('evaluacionesAntecedentes', ['fetchEvaluacionesAntecedentesByExpediente']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async openExpedientePersonalDialog(expediente) {
      this.loadingExpediente = true;
      this.overlay = true;
      this.SET_SNACKBAR_MESSAGE('Cargando información de expediente. Este proceso puede tardar un par de minutos.');
      this.selectedExpediente = expediente;
      await this.fetchEstudiosByPersonal(expediente.Personal.idPersonal);
      await this.fetchBiometricosExpediente(expediente.idExpediente);
      await this.fetchFamiliares(expediente.Personal.idPersonal);
      await this.fetchDocumentoByPersonal(expediente.Personal.idPersonal);
      await this.fetchVehiculos(expediente.Personal.idPersonal);
      await this.fetchBoletasArresto(expediente.Personal.idPersonal);
      await this.fetchSancionesAdministrativas(expediente.Personal.idPersonal);
      await this.fetchSituacionFinanciera(expediente.idExpediente);
      await this.fetchDatosLaborales(expediente.idExpediente);
      await this.fetchEvaluacionesMedicoByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesPsicologicasByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesPoligrafoByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesIseByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesValidacionByExpediente(expediente.idExpediente);
      await this.fetchProgramacionesEvaluacionesByExpediente(expediente.idExpediente);
      await this.fetchHistoriasClinicasByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesIntegracionByExpediente(expediente.idExpediente);
      await this.fetchSeguimientoEvaluacionByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesAntecedentesByExpediente(expediente.idExpediente);
      this.expedientePersonalDialog = true;
      this.overlay = false;
      this.loadingExpediente = false;
    },

    async openEditFolioExpedienteDialog(expediente) {
      this.selectedExpediente = expediente;
      this.editarFolioExpedienteDialog = true;
    },

    async openNuevaProgramacionDialog(expediente) {
      this.selectedExpediente = expediente;
      this.nuevaProgramacionDialog = true;
    },

    async openListaProgramacionesDialog(expediente) {
      this.overlay = true;
      await this.fetchProgramacionesEvaluacionesByExpediente(expediente.idExpediente);
      this.selectedExpediente = expediente;
      this.overlay = false;
      this.listaProgramacionesDialog = true;
    },
  },
};
</script>
